export default __webpack_public_path__ + "static/media/icons8-washer-fluid.f6e60923.svg";